import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Job, Role, AddNewUserInfo } from 'src/app/models';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { UserService, ToastService } from 'src/app/services';
import { emailRegex } from 'src/app/resources/Constants';
import { Company } from 'src/app/models/user-info.model';
import { AddEditOrganizationModalComponent } from 'src/app/shared-components/add-edit-organization-modal/add-edit-organization-modal.component';
import { CompanyAnalysisComponent } from 'src/app/pages/tool/sub-tool/company-analysis/company-analysis.component';


@Component({
    selector: 'app-add-user-modal',
    templateUrl: './add-user-modal.component.html',
    styleUrls: ['./add-user-modal.component.scss'],
    standalone: false
})


export class AddUserModalComponent implements OnInit {

  // tslint:disable-next-line: no-output-native
  @Output() submit: EventEmitter<AddNewUserInfo> = new EventEmitter();
  submitted = false;
  validation: boolean;
  addNewUserForm: UntypedFormGroup;
  jobsPrivilegesAvailable: any[] = [];
  //jobSelected: Job;
  roleSelected: string;
  //jobsAvailable: Job[];
  rolesAvailable: Role[];
  //filteredRoles: Role[];
  loader = false;
  showFormExtra = false;
  companiesAvailable: Company[];
  companySelected: string;
  isCreatingNew: boolean = false;
  special_property = [];
  new_property = { key: "", value: "" }
  constructor(
    public activeModal: NgbActiveModal,
    public toastService: ToastService,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private modalService: NgbModal
  ) { }

  async ngOnInit() {
    this.addNewUserForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailRegex)]],
      name: [''],
      surname: [''],
      company: [null, Validators.required],
    });
    try {
      this.loader = true;
      //this.jobsAvailable = (await this.userService.getJobs()).job_titles;
      this.jobsPrivilegesAvailable = (await this.userService.getAvailableToolsAndPrivileges());
      // console.log(this.jobsPrivilegesAvailable)
      this.rolesAvailable = (await this.userService.getRoles()).roles;
      //this.jobSelected = this.jobsAvailable.find((job: Job) => job.is_selected);
      this.roleSelected = this.rolesAvailable?.find((role: Role) => role.role === 'public')?.role;
      this.companiesAvailable = (await this.userService.getCompanies()).companies;
      let companySelectedValue = this.companiesAvailable.length == 1 ? this.companiesAvailable[0].guid : undefined;
      if (companySelectedValue !== undefined) {
        this.addNewUserForm.get('company').patchValue(companySelectedValue);
      }
      this.addNewUserForm.updateValueAndValidity();
      this.loader = false;
    } catch (error) {
      this.loader = false;
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Get reactive form
   */

  get newUserForm() { return this.addNewUserForm.controls; }

  /**
   * Modal submit
   */

  onSubmit() {
    //console.log("submit")
    this.submitted = true;
    if (this.addNewUserForm.valid) {
      this.special_property=this.special_property.filter((x)=>x.key != "" && x.value != "");
      this.submit.emit({
        ...this.addNewUserForm.value,
        role: this.roleSelected,
        tool_privileges: this.jobsPrivilegesAvailable.map(el => {
          return {
            privileges: el.access_level,
            tool_name: el.tool_informations.tool_name,
            id_tool: el.tool_informations.id_tool
          }
        }),
        special_property : this.special_property
      });
      this.activeModal.close();
    }
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }

  /**
   * Returns the selected job from job dropdown
   * @param job Selected job
   */

  getSelectedJob(job: Job) {
    //console.log("get selected jobs")
    /*
job.is_selected = true;
this.jobSelected = job;
this.jobsAvailable.map(
  (value: Job) => {
    value.is_selected = value.name === job.name;
  }
);*/
  }

  /**
   * Returns the selected role from role dropdown
   * @param role Selected role
   */
  getSelectedRole(role: Role) {
    this.roleSelected = role.role;
  }

  /**
   * Live search of the typeahead that calls getAvailableUsers() (Typeahead ng-bootstrap)
   * @param text$ Entered text
   */
  search = (text$: Observable<string>) => {
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((searchText) => this.getAvailableUsers(searchText)),
    );
  }

  async getAvailableUsers(email: string) {
    const noUser = {
      name: '',
      surname: '',
      email,
      company: ''
    };
    if (email === '') {
      return [];
    }
    try {
      const userList = (await this.userService.getUsersAvailable(email)).users_available;
      let users = userList.filter(v => v.email.toLowerCase().indexOf(email.toLowerCase()) > -1);
      users = users.length === 0 ? [noUser] : users;
      return users;
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
      return [noUser];
    }
  }

  /**
   * Format the returned item
   * @param x Item
   */

  formatter = (x: AddNewUserInfo) => x;

  /**
   * Returns the user selected in the search
   * @param selectedItem User selected
   */

  getSelectedItem(selectedItem: NgbTypeaheadSelectItemEvent) {
    selectedItem.preventDefault();
    const name = this.addNewUserForm.get('name') as UntypedFormControl;
    const surname = this.addNewUserForm.get('surname') as UntypedFormControl;
    if (selectedItem.item.name === '') {
      this.showFormExtra = true;
      name.setValidators([Validators.required]);
      surname.setValidators([Validators.required]);
    }
    this.addNewUserForm.patchValue({
      email: selectedItem.item.email,
      name: selectedItem.item.name,
      surname: selectedItem.item.surname,
    });
    name.updateValueAndValidity();
    surname.updateValueAndValidity();
  }

  filterRoles() {
    //console.log("!Filtering roles....")
    //this.filteredRoles = this.addNewUserForm.value.company && this.addNewUserForm.value.company.value==='' ? [] : []
    //this.rolesAvailable.filter(role => role.isDefault) :
    //this.rolesAvailable.filter(role => role.available_companies.indexOf(this.addNewUserForm.value.company) !== -1);
    //this.roleSelected = this.filteredRoles.find((role: Role) => role.role === 'contributor').role;

  }

  /**
 * Opens the modal to create new Organization
 */

  openCreateNewOrganizationModal() {
    //console.log("Creating new Organization....")
    const modalRef = this.modalService.open(AddEditOrganizationModalComponent, { centered: true, size: '50%', backdrop: 'static' });
    modalRef.componentInstance.submit.subscribe(async (companyName: string) => {
      this.isCreatingNew = true;
      const response = (await this.userService.addNewOrganization(companyName));
      this.companiesAvailable = [...this.companiesAvailable, { guid: response.detail, name: companyName }];
      this.addNewUserForm.get('company').patchValue(response.detail);
      this.addNewUserForm.updateValueAndValidity();
      //this.rolesAvailable =  (await this.userService.getRoles()).roles;
      this.filterRoles();
      this.isCreatingNew = false;
    });

  }

  changeUserRole(tool: any, r: string) {
    tool.access_level = r;
  }

  deleteProperty(i) {
    this.special_property.splice(i, 1)
  }

  addProperty() {
    //if (this.new_property.key == "" || this.new_property.value == "") return;
    this.special_property.push({ key: "", value: "" });
    // console.log(this.special_property);
    //this.new_property = { key: "", value: "" }
  }

  trackByIdx(index: number, obj: any): any {
    return index;
  }

}
